export default function (report) {
  const formattedReport = report
    .replace('NWS Employee', 'NWS employee')
    .replace('Trained Spotter', 'trained spotter')
    .replace('CoCoRaHS', 'COCORAHS')
    .replace('Official NWS Obs', 'official NWS observation')
    .replace('Public', 'public')
    .replace('Brodacast Media', 'broadcast media')
    .replace('Emergency Mngr', 'emergency manager')
    .replace('PUBLIC', 'public')
    .replace('LAW ENFORCEMENT', 'law enforcement')
    .replace('CO-OP Observer', 'CO-OP observer')
    .replace('TRAINED SPOTTER', 'trained spotter')
    .replace('Radio', 'radio')
    .replace('Amatuer', 'amateur');

  if (report.toLowerCase() === 'n/a') {
    return ' The source of the report was unavailable.';
  } return ` The source of the report was listed as <strong>${formattedReport}.</strong>`;
}
